import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import {
    Button,
    MenuItem,
    Menu,
} from "@mui/material";
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import StorefrontIcon from '@mui/icons-material/Storefront';
import MailIcon from '@mui/icons-material/Mail';
import VipFormerLogo from '../assets/images/logo.png';
import Avatar from '@mui/material/Avatar';
import WelcomeScreen from "./WelcomeScreen.js";
import { Outlet } from "react-router-dom";
import HomePage from './Homepage';
import { ReactComponent as MyCandidatesWhiteIcon } from "../assets/images/myCandidate-whiteIcon.svg";
import { ReactComponent as AnalyticsActiveIcon } from "../assets/images/credit.svg";
import { ReactComponent as Inventory } from "../assets/images/inventory-management.svg";
import { ReactComponent as ImportIcon } from "../assets/images/import.svg";
import { ReactComponent as Analytics } from "../assets/images/analytics-white-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
// import { Tooltip, TooltipTrigger, TooltipContent } from 'react-tippy';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useState, useEffect } from 'react';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ExportModal from './ExportModal';
import { getErrorMessage } from '../utils/helper.js';
import { danger, success } from '../utils/message-box.js';
import axiosInstance from '../Services/axiosInstance.js';
import { isAdminUser } from '../utils/auth.js';
import { getSpecialDay } from '../utils/specialDays.js';


const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));

const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);
export default function MiniDrawer() {
    const navigate = useNavigate();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [anchorE2, setAnchorE2] = React.useState(null);
    const open2 = Boolean(anchorE2);
    const [specialDay, setSpecialDay] = useState(null);
    const [exportModalOpen, setExportModalOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(!open);
    };
    const handleClick2 = (event) => {
        setAnchorE2(event.currentTarget);
    };
    const signOut = () => {
        localStorage.clear();
        navigate('/signin');
    }
    const handleClose2 = () => {
        setAnchorE2(null);
    };
    const handleExportClick = () => {
        setExportModalOpen(true);
        handleClose2(); // Close the menu
    };
    const handleExportDownload = async (mobileNumber, startDate, endDate) => {
        try {
            const params = { start_date: startDate, end_date: endDate, created_by: mobileNumber };
            const response = await axiosInstance.get('/api/v1/customers/export', {
                responseType: 'blob',
                params,
            });
            const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
            // Create a link element to trigger the download
            const link = document.createElement('a');
            link.href = urlBlob;
            link.setAttribute('download', 'customers.xlsx'); // Filename
            document.body.appendChild(link);
            link.click();
            // Clean up and remove the link
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(urlBlob);
            setExportModalOpen(false);
            success('Document downloaded successfully.');
        } catch (error) {
            danger(getErrorMessage(error, 'Failed to download file. Please try again.'));
            console.error('There was an error downloading the file:', error);
        }
    };
    useEffect(() => {
        try {
            setSpecialDay(getSpecialDay(new Date()));
        } catch (error) {
            console.error('Error fetching special days:', error);
        }
    }, []);
    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                open={open}
                sx={{
                    backgroundColor: '#fff',
                    zIndex: 99,
                    boxShadow: '0 1px 0 rgba(15, 23, 42, 0.06)',
                }}
            >
                <Toolbar sx={{ display: 'flex', alignItems: 'center', gap: 2, minHeight: { xs: 64 } }}>
                    <Box sx={{ flex: 1, minWidth: 0 }} />
                    <Box
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        {specialDay && (
                            <Box
                                role="status"
                                aria-live="polite"
                                aria-label={`Happy ${specialDay.name}`}
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 1.25,
                                    maxWidth: '100%',
                                    px: 1.5,
                                    py: 0.6,
                                    borderRadius: '999px',
                                    background: 'linear-gradient(135deg, #FFF7ED 0%, #FFEDD5 100%)',
                                    border: '1px solid rgba(234, 88, 12, 0.18)',
                                    boxShadow: '0 4px 14px rgba(234, 88, 12, 0.1)',
                                }}
                            >
                                <Box
                                    component="span"
                                    aria-hidden
                                    sx={{
                                        width: 30,
                                        height: 30,
                                        flexShrink: 0,
                                        borderRadius: '50%',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        bgcolor: '#fff',
                                        fontSize: 16,
                                        lineHeight: 1,
                                        boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
                                    }}
                                >
                                    {specialDay.emoji}
                                </Box>
                                <Box sx={{ minWidth: 0, pr: 0.5 }}>
                                    <Typography
                                        component="p"
                                        sx={{
                                            m: 0,
                                            fontSize: 10,
                                            fontWeight: 700,
                                            letterSpacing: '0.08em',
                                            textTransform: 'uppercase',
                                            color: '#C2410C',
                                            lineHeight: 1.2,
                                        }}
                                    >
                                        Today
                                    </Typography>
                                    <Typography
                                        component="p"
                                        noWrap
                                        title={`Happy ${specialDay.name}`}
                                        sx={{
                                            m: 0,
                                            fontSize: { xs: 13, sm: 14 },
                                            fontWeight: 700,
                                            color: '#1C1917',
                                            lineHeight: 1.25,
                                        }}
                                    >
                                        Happy {specialDay.name}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        {/* <Box>
                            <img src={VipFormerLogo} alt="Company Logo" style={{ height: 50 }} />
                        </Box> */}
                        {/* <Box sx={{ display: 'flex', alignItems: 'center' }}> */}
                        <Typography className='text-capitalize' variant="body1" sx={{ color: '#000' }}>
                            {localStorage.getItem('username')}
                        </Typography>
                        <Button
                            id="basic-button-menu"
                            aria-controls={open2 ? "account-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open2 ? "true" : undefined}
                            // aria-controls="basic-menu2"
                            className="dropdown-arrow text-transform-none cursor-hover position-issue pxy-8"
                            onClick={handleClick2}
                            role="switch"
                            aria-checked={open2 ? "true" : "false"}
                            tabIndex={0}
                            disableRipple="true"
                        >
                            <IconButton>
                                {/* <Avatar alt="Profile Picture" src="profile.jpg" /> */}
                                <Typography
                                    className="default-img-border justify-center align-center display-flex primary-btn-text bg-input f-16 font-weight-700 text-capitalize candidate-profile"
                                    width="42px"
                                    height="42px"
                                    aria-label="Default image"
                                >
                                    {localStorage.getItem('username')
                                        .trim()
                                        .substring(0, 1)}
                                </Typography>
                            </IconButton>
                            {/* <ExpandMoreIcon
                      className="ml-10 cursor-hover headerIcon inputcontrasts fill-svg-icons gray9"
                      aria-label="Dropdown icon"
                    /> */}
                        </Button>
                        <Menu
                            id="account-menu"
                            anchorEl={anchorE2}
                            open={open2}
                            className="cursor-hover header-menu"
                            onClose={handleClose2}
                            disableScrollLock={true}
                            MenuListProps={{
                                "aria-labelledby": "basic-button-menu",
                            }}
                            Keepmounted
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                        >
                            {isAdminUser() && <MenuItem
                                className="cursor-hover pl-30 pt-10 border-menu-top"
                                onClick={handleExportClick}
                                onMouseDown={handleExportClick}
                                onMouseUp={handleExportClick}
                            >
                                <FileDownloadIcon sx={{ width: 24, height: 24 }} />
                                <span className="pl-10 p-t-2">Export</span>
                            </MenuItem>}
                            {/* <MenuItem
                                className="cursor-hover pl-30 pt-10 border-menu-top"
                                onClick={() => {
                                    handleClose2();
                                    navigate('/resetpassword');
                                }}
                            >
                                <span className="pl-10 p-t-2">Reset Password</span>
                            </MenuItem> */}
                            <MenuItem
                                className="danger-color cursor-hover pl-30 pt-10 border-menu-top"
                                onClick={signOut}
                                onKeyPress={signOut}
                                onMouseDown={signOut}
                                onMouseUp={signOut}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="danger-color"
                                    width="24px"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
                                    />
                                </svg>
                                <span className="pl-10 p-t-2">Logout</span>
                            </MenuItem>
                        </Menu>
                        {/* </Box> */}
                    </Box>
                </Toolbar>
            </AppBar>
            <Drawer variant="permanent" open={open} className='drawer-color'>
                <DrawerHeader className='p-0 d-flex justify-center'>
                    <img src={VipFormerLogo} className='cursor-hover' alt="Company Logo" style={{ height: 50 }} onClick={() => navigate('/home')} />
                </DrawerHeader>
                <List>
                    {(isAdminUser() ? ['Customers', 'Inventory', 'Amount Deposites', 'Imports', 'Analytics', 'Attendance', 'Vendors'] : ['Customers', 'Inventory', 'Amount Deposites', 'Attendance']).map((text, index) => (
                        <ListItem key={text} disablePadding sx={{ display: 'block' }} onClick={() => navigate(text === 'Customers' ? '/customerList' : text === 'Inventory' ? '/summary' : text === 'Analytics' ? '/reports' : text === 'Imports' ? '/imports' : text === 'Attendance' ? '/attendance' : text === 'Vendors' ? '/list-vendors' : '/amountHistory')}>
                            <BootstrapTooltip title={text === 'Customers' ? 'Customers' : text === 'Inventory' ? 'Inventory' : text === 'Imports' ? 'Imports' : text === 'Analytics' ? 'Analytics' : text === 'Attendance' ? 'Attendance' : text === 'Vendors' ? 'Vendors' : 'PO Balance Overview'} position="left"
                                trigger="mouseenter"
                                animation="fade"
                                placement="right"
                                duration={0}
                                distance={0}
                                arrow>
                                <ListItemButton
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: open ? 'initial' : 'center',
                                        px: 2.5,
                                        cursor: 'hover'
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: 0,
                                            mr: open ? 3 : 'auto',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        {text === 'Customers' ? <MyCandidatesWhiteIcon className='cursor-hover' width='26px' height='26px' /> : text === 'Inventory' ? <Inventory width='24px' height='24px' className='sidebar-icons'/> : text === 'Imports' ? <ImportIcon width='22px' height='24px' className='sidebar-icons1 ml-3'/> : text === 'Analytics' ? <Analytics width='24px' height='24px' className='sidebar-icons1'/> : text === 'Attendance' ? <InboxIcon sx={{ color: '#fff' }} className='emp-width' /> : text === 'Vendors' ? <StorefrontIcon sx={{ color: '#fff' }} className='emp-width' /> : <AnalyticsActiveIcon width='24px' height='24px' className='sidebar-icons1'/>}
                                    </ListItemIcon>
                                    <ListItemText primary={text} sx={{ opacity: open ? 1 : 0, color: '#fff' }} />
                                </ListItemButton>
                            </BootstrapTooltip>
                        </ListItem>
                    ))}
                </List>
                <DrawerHeader className='drawer-icon'>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon className='drawer-buuton' width='20px' height='20px' /> : <ChevronLeftIcon className='drawer-buuton' width='20px' height='20px' />}
                    </IconButton>
                </DrawerHeader>
            </Drawer>
            <Box component="main" className='main-div-padding' sx={{ flexGrow: 1, minWidth: 0, width: '100%' }}>
                <HomePage />
            </Box>
            <ExportModal 
                open={exportModalOpen} 
                onClose={() => setExportModalOpen(false)}
                onDownload={handleExportDownload}
            />
        </Box>
    );
}
